import React from 'react';
import {ProgressBarStepModel} from './model';
import {ProgressStepComponent} from './ProgressStepComponent';
import classNames from 'classnames';

interface CompletedProgressStepProps extends ProgressBarStepModel {
  onClick?: () => void;
  justCompleted?: boolean;
}

export const CompletedProgressStep: React.FC<CompletedProgressStepProps> = ({
  id,
  onClick,
  disabled,
  selected,
  justCompleted,
}) => {
  return (
    <ProgressStepComponent
      id={id}
      onClick={onClick}
      disabled={disabled}
      selected={selected}
      className={classNames({ 'progress-bar__step--just-completed': justCompleted })}
    />
  );
};
